import React, { FC } from 'react';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import FadeIn, { FADEIN } from 'framers/FadeIn';
import Multiselect from 'multiselect-react-dropdown';

import { Container } from 'layout';
import Typography from 'common/Typography';
import Button from 'components/Button';

import { stringToCategoryTag } from 'utils/stringToCategoryTag';
import { useScreenService } from 'hooks/useScreenService';

import { CategoriesListProps } from './models';

import './CategoriesList.scss';

const { DOWN } = FADEIN;

const CategoriesList: FC<CategoriesListProps> = ({
  filtersTitle,
  dropdownPlaceholder,
  allTags,
  tags,
  selectedCategories,
  introCopyText,
  handleSelectedCategories,
  isH1,
}) => {
  const { isSm } = useScreenService();

  const onSelect = (_, { name }) => {
    handleSelectedCategories?.(name);
  };

  const onRemove = (_, { name }) => {
    handleSelectedCategories?.(name);
  };

  const selectedValues = tags.filter(({ name }) =>
    selectedCategories.includes(stringToCategoryTag(name))
  );

  const availableTags = tags.filter(({ tag }) => allTags?.includes(stringToCategoryTag(tag)));

  return tags ? (
    <Container>
      <section className="categories" data-testid="categories">
        <Typography
          as={isH1 ? 'h1' : 'p'}
          weight="semi-bold"
          size={{ base: 22, md: 30 }}
          animationVariant={DOWN}
          color="sherwood-green"
        >
          {filtersTitle}
        </Typography>
        {introCopyText ? (
          <Typography
            dangerouslySetInnerHTML={introCopyText}
            size={18}
            className="intro-copy-text"
            animationVariant={DOWN}
          />
        ) : null}
        {isSm ? (
          <FadeIn>
            <Multiselect
              displayValue="name"
              showArrow
              closeOnSelect
              className="categories__mobile"
              placeholder={dropdownPlaceholder}
              hidePlaceholder
              {...{ onSelect, onRemove, selectedValues }}
              customArrow={<FontAwesomeIcon icon={faAngleDown} size="1x" />}
              options={availableTags}
            />
          </FadeIn>
        ) : (
          <FadeIn>
            <ul className="categories__items">
              {tags.map(({ name, tag, id }) => {
                const isActive: boolean = selectedCategories.includes(stringToCategoryTag(tag));

                return (
                  <li className="categories__item" key={`${id} + ${name}`}>
                    <Button
                      onClick={() => handleSelectedCategories?.(name)}
                      className={classNames('categories__btn', {
                        'categories__btn--active': isActive,
                      })}
                      ui={{
                        variant: 'simple',
                        backgroundColor: 'transparent',
                        typography: { size: 22 },
                      }}
                    >
                      {name}
                    </Button>
                  </li>
                );
              })}
            </ul>
          </FadeIn>
        )}
      </section>
    </Container>
  ) : null;
};
export default CategoriesList;
